export default __webpack_public_path__ + "static/media/userAgreement.1fa6e475.md";